module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Burg_im_Leimental-b352df329961b377b866baeff035c1fc.svg";